export const POST_AUTH_REDIRECT_KEY = 'postAuthRedirect';

export function stashPostAuthRedirect(path) {
  if (typeof sessionStorage === 'undefined' || !path) return;
  sessionStorage.setItem(POST_AUTH_REDIRECT_KEY, path);
}

export function consumePostAuthRedirect() {
  if (typeof sessionStorage === 'undefined') return null;
  const value = sessionStorage.getItem(POST_AUTH_REDIRECT_KEY);
  if (value) sessionStorage.removeItem(POST_AUTH_REDIRECT_KEY);
  return value;
}

export function getPostAuthRedirect({
  isNewUser,
  pendingRedirectUrl,
  pendingSubscription,
  defaultHref
}) {
  const storedRedirect = consumePostAuthRedirect();
  if (pendingRedirectUrl) return pendingRedirectUrl;
  if (pendingSubscription) return '/pricing';
  const fallback = defaultHref || storedRedirect;
  if (isNewUser) {
    const next = fallback && fallback !== '/'
      ? `?next=${encodeURIComponent(fallback)}`
      : '';
    return `/welcome/menu-preferences${next}`;
  }
  return fallback || null;
}
